<template>
  <div>
    <div class="text-xs-center grey--text" v-if="nodes.length == 0">Empty</div>
    <div v-else>
      <v-pagination v-model="pageNumber" :length="pagelength" class="mb-2"></v-pagination>
      <div v-for="node in filterNode" :key="node.id">
        <v-chip @click="$emit('onSelect', node)" small :color="$store.state.colorlist[node.type]">
          <v-icon class="mr-2" v-if="node.type == 'node'">web_asset</v-icon>
          <v-icon class="mr-2" v-if="node.type == 'api'">http</v-icon>
          <v-icon class="mr-2" v-if="node.type == 'random'">shuffle</v-icon>
          <v-icon class="mr-2" v-if="node.type == 'condition'">call_split</v-icon>
          <v-icon class="mr-2" v-if="node.type == 'flow'">account_tree</v-icon>
          <v-icon class="mr-2" v-if="node.type == 'start_node'">outlined_flag</v-icon>
          {{ node.intentname }}
        </v-chip>
      </div>
      <v-pagination v-model="pageNumber" :length="pagelength" class="mb-2"></v-pagination>
    </div>
  </div>
</template>

<script>
import api from '@/api'
export default {
  props: ['value'],
  data() {
    return {
      flow: null,
      nodes: [],
      loading: true,
      size: 20,
      pageNumber: 1,
    }
  },
  async mounted() {
    this.flow = this.value
    this.nodes = await this.getFlowAllIntents()
  },
  computed: {
    filterNode() {
      const start = (this.pageNumber - 1) * this.size
      const end = start + this.size
      return this.nodes.slice(start, end)
    },
    pagelength() {
      if (this.nodes) {
        return Math.ceil(this.nodes.length / this.size)
      } else {
        return 1
      }
    },
  },
  methods: {
    getFlowAllIntents() {
      return new Promise((resolve, reject) => {
        var data = { flowid: this.flow.id }
        api.getFlowAllIntents(data, function (error, response) {
          if (error) {
            reject(error)
            return
          }
          if (response.data) {
            resolve(response.data)
          } else {
            resolve([])
          }
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/flow/FlowNodeManage.vue